module.exports = __webpack_public_path__ + "img/facilityInfo_2_2.0726d24f.jpg";